import { jsx as m } from "react/jsx-runtime";
import { clsx as e } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import o from "./roche-control-group.module.scss.js";
const p = ({ isGrowing: r = !1, children: t }) => /* @__PURE__ */ m("div", { className: e(o["control-group__item"], r && o["control-group__item--growing"]), children: t });
export {
  p as RocheUIControlGroupItem
};
